import React, { createContext, useState } from "react";
import * as Icons from "@material-ui/icons";
import {
  IPAlign,
  IPBox,
  IPCenter,
  IPContainer,
  IPExitButton,
} from "../assets/styles/InformationPopUp";

export const InformationPopUpContext = createContext({});

function InformationPopUp({ children }) {
  const CloseIcon = Icons["Close"];
  const [information, setInformation] = useState();

  return (
    <InformationPopUpContext.Provider
      value={{ showInformationPopUp: setInformation }}
    >
      {children}

      {information && (
        <IPContainer>
          <IPCenter>
            <IPAlign>
              <IPExitButton
                onClick={() => {
                  if (information.onClose) {
                    information.onClose();
                  }
                  setInformation();
                }}
              >
                <CloseIcon
                  fontSize="small"
                  color="inherit"
                  style={{ margin: 3 }}
                />
              </IPExitButton>

              <IPBox>
                <h2>{information?.title || "Houve um problema..."}</h2>

                {information?.message?.constructor === [].constructor ? (
                  information?.message.map((item) => <p key={item}>{item}</p>)
                ) : (
                  <p>{information?.message}</p>
                )}
              </IPBox>
            </IPAlign>
          </IPCenter>
        </IPContainer>
      )}
    </InformationPopUpContext.Provider>
  );
}

export default InformationPopUp;
